import {filterStateActions} from '@app/components/right-sidebar/redux';
import {routeStateActions} from '@app/router/redux';
import {useEffect, useState} from 'react';
import {RootStateOrAny, useDispatch, useSelector} from 'react-redux';
import {
  setRightSidebarToggle,
  setSubTabSwitch,
  updateRequestPayload,
} from '../redux/tabName';
import {navbarComponentName} from '@app/router/redux/routeHandler';

import {Box} from '@mui/material';
import ManageProductView from './components/ManageProductView';
import ManageProductFilter from './components/manageProductFilter';

const ManageProductStatus = ({userLoginInfo}: any) => {
  const dispatch = useDispatch();
  const [addProductPayload, setAddProductPayload] = useState({
    divisionId: 0,
    candFid: [],
    hqid: [],
    partyId: [],
    stockistId: [],
    productId: null,
    createdBy: 0,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const requestPayload = useSelector(
    (state: RootStateOrAny) => state.tabNames.value.requestPayload,
  );

  useEffect(() => {
    dispatch(filterStateActions.setFilterState({}));
    dispatch(
      routeStateActions.setNavbarComponentName(navbarComponentName.fcAdmin),
    );
    dispatch(setRightSidebarToggle(false));
    return () => {
      dispatch(
        updateRequestPayload({
          ...requestPayload,
          pageNumber: 0,
        }),
      );
      dispatch(filterStateActions.setFilterState({}));
      dispatch(routeStateActions.setNavbarComponentName(null));
      dispatch(setSubTabSwitch(1));
    };
  }, []);

  const clearPayload = () => {
    setAddProductPayload({
      divisionId: 0,
      candFid: [],
      hqid: [],
      partyId: [],
      stockistId: [],
      productId: null,
      createdBy: 0,
    });
  };
  return (
    <Box
      sx={{maxHeight: 'calc(100vh - 155px)', overflow: 'auto'}}
      className="hgghgi-ff">
      <ManageProductFilter
        pageNo={page}
        rowsPerPage={rowsPerPage}
        addProductPayload={addProductPayload}
        setAddProductPayload={setAddProductPayload}
        userLoginInfo={userLoginInfo}
        margin={true}
        clearPayload={clearPayload}
      />
      <ManageProductView
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        userLoginInfo={userLoginInfo}
      />
    </Box>
  );
};

export default ManageProductStatus;
